<template>
  <el-container style="width:100%;">
    <el-header>
      <el-row type="flex" align="middle">
        <el-col style="line-height: 60px;">
          <el-button round @click="onRefersh">{{generateCustomizeString('refresh')}}</el-button>
          <el-button
            round
            @click="paidExcel"
          >{{ generateCustomizeString('batchExportOrders') }}</el-button>
          <el-button
            round
            v-if="searchForm.status === 10"
            @click="printOrder"
          >{{ generateCustomizeString('batchPrintInvoice') }}</el-button>
          <el-button
            round
            v-if="searchForm.status === 15"
            @click="pickingExcel"
          >{{ generateCustomizeString('batchExportPickingInfo') }}</el-button>
        </el-col>
      </el-row>
    </el-header>
    <el-main>
      <el-row>
        <el-col :span='24'>
          <el-form
          :inline="true"
          >
          <el-form-item label="快速查找">
              <el-button
              size="small"
              type="primay"
              @click="onQuickSearch(-1)"
              round>{{generateCustomizeString('allOrders')}}</el-button>
              <el-button
              size="small"
              type="primay"
              @click="onQuickSearch(10)"
              round>{{generateCustomizeString('paidOrders')}}</el-button>
              <el-button
              size="small"
              type="primay"
              @click="onQuickSearch(0)"
              round>{{generateCustomizeString('unpaidOrders')}}</el-button>
              <el-button
              size="small"
              type="primay"
              @click="onQuickSearch(15)"
              round>{{generateCustomizeString('pickingOrders')}}</el-button>
              <el-button
              size="small"
              type="primay"
              @click="onQuickSearch(20)"
              round>{{generateCustomizeString('shippedOrders')}}</el-button>
              <!-- ## -->
              <el-button
              size="small"
              type="primay"
              @click="onQuickSearch(50)"
              round>{{generateCustomizeString('requestRefundOrders')}}</el-button>
              <el-button
              size="small"
              type="primay"
              @click="onQuickSearch(60)"
              round>{{generateCustomizeString('refundFinishedOrders')}}</el-button>
              <el-button
              size="small"
              type="primay"
              @click="onQuickSearch(90)"
              round>{{generateCustomizeString('closedOrders')}}</el-button>
              <el-button
              size="small"
              type="primay"
              @click="onQuickSearch(40)"
              round>{{generateCustomizeString('completedOrders')}}</el-button>
            </el-form-item>

          </el-form>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form
            :inline="true"
            ref="searchForm"
            :model="searchForm"
            class="search-form-inline"
            size="mini"
          >
            <el-form-item :label="generateCustomizeString('orderTimeRange')">
              <el-date-picker
                v-model="searchForm.datetimeRange"
                type="datetimerange"
                :picker-options="datetimeRangePickerOptions"
                range-separator="-"
                :start-placeholder="generateCustomizeString('start')"
                :end-placeholder="generateCustomizeString('end')"
                :default-time="['00:00:00', '23:59:59']"
                align="right"
                style="width: 460px;"
              ></el-date-picker>
            </el-form-item>
            <el-form-item :label="generateCustomizeString('orderId')" style="margin-left: 20px;">
              <el-input
                v-model="searchForm.out_trade_no"
                :placeholder="generateCustomizeString('enterTheOrderId')"
                resize="horizontal"
                @keyup.enter.native="onSearch"
              ></el-input>
            </el-form-item>
            <el-form-item :label="generateCustomizeString('orderStatus')" style="margin-left: 20px;">
              <el-select
                v-model="searchForm.status"
                style="width: 176px;"
              >
                <el-option :value="-1" :label="generateCustomizeString('allOrders')"></el-option>
                <el-option :value="5" :label="generateCustomizeString('partUnpaidOrders')"></el-option>
                 <el-option :value="50" :label="generateCustomizeString('requestRefundOrders')"></el-option>
                <el-option :value="60" :label="generateCustomizeString('refundFinishedOrders')"></el-option>
                <el-option :value="40" :label="generateCustomizeString('completedOrders')"></el-option>
                <el-option :value="90" :label="generateCustomizeString('closedOrders')"></el-option>
                <el-option :value="0" :label="generateCustomizeString('unpaidOrders')"></el-option>
                <el-option :value="10" :label="generateCustomizeString('paidOrders')"></el-option>
                <el-option :value="15" :label="generateCustomizeString('pickingOrders')"></el-option>
                <el-option :value="20" :label="generateCustomizeString('shippedOrders')"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              v-if="this.$route.params.displayName"
              :label="generateCustomizeString('customerName')"
              style="margin-left: 20px;"
            >
              <el-tag size="mini">{{this.$route.params.displayName}}</el-tag>
            </el-form-item>
            <el-form-item style="float: right; right: 30px;">
              <el-button type="primary" @click="onSearch">{{generateCustomizeString('search')}}</el-button>
              <el-button @click="onReset">{{generateCustomizeString('reset')}}</el-button>
            </el-form-item>
            <el-col :span="24">
              <el-col :span="24">
                <div
                  @click="searchOthers = !searchOthers"
                  v-show="!searchOthers"
                  style="text-align: center; color: #969696;"
                >
                  <i class="el-icon-arrow-down"></i>
                  <span style="font-size: 14px;">{{ generateCustomizeString('more') }}</span>
                </div>
              </el-col>
              <div>
                <div>
                  <div v-show="searchOthers">
                    <el-col :span="24">
                      <el-col :span="6">
                        <el-form-item
                          :label="generateCustomizeString('customerName')"
                          style="margin-left: 28px;"
                        >
                          <el-input
                            v-model="searchForm.phone"
                            :placeholder="generateCustomizeString('customerName')"
                            resize="horizontal"
                            @keyup.enter.native="onSearch"
                          ></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="6">
                        <el-form-item
                          :label="generateCustomizeString('wechatName')"
                          style="margin-left: 14px;"
                        >
                          <el-input
                            v-model="searchForm.wx_nickname"
                            :placeholder="generateCustomizeString('wechatName')"
                            resize="horizontal"
                            @keyup.enter.native="onSearch"
                          ></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="6">
                        <el-form-item
                          style="margin-left: 0px;"
                          :label="generateCustomizeString('orderSort')"
                        >
                          <el-select
                            v-model="searchForm.order"
                            placeholder="generateCustomizeString('pleaseSelect')"
                            @change="orderSortClick"
                          >
                            <el-option
                              v-for="item in orderByOptions"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                            ></el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="3">
                        <el-form-item>
                          <el-checkbox
                            v-model="searchForm.is_pick_up"
                            :label="generateCustomizeString('isPickUpOrder')"
                            border
                          ></el-checkbox>
                        </el-form-item>
                      </el-col>
                    </el-col>
                    <el-col :span="24">
                      <el-col :span="6">
                        <el-form-item
                          :label="generateCustomizeString('shippingPerson')"
                          style="margin-left: 41px;"
                        >
                          <el-input
                            v-model="searchForm.consignee_name"
                            :placeholder="generateCustomizeString('shippingPerson')"
                            resize="horizontal"
                            @keyup.enter.native="onSearch"
                          ></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="6">
                        <el-form-item
                          :label="generateCustomizeString('consigneePhone')"
                          style="margin-left: 0px;"
                        >
                          <el-input
                            v-model="searchForm.consignee_phone"
                            :placeholder="generateCustomizeString('consigneePhone')"
                            resize="horizontal"
                            @keyup.enter.native="onSearch"
                          ></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="6">
                        <el-form-item
                          :label="generateCustomizeString('senderName')"
                          style="margin-left: 14px;"
                        >
                          <el-input
                            v-model="searchForm.sender_name"
                            :placeholder="generateCustomizeString('senderName')"
                            resize="horizontal"
                            @keyup.enter.native="onSearch"
                          ></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="6">
                        <el-form-item
                          :label="generateCustomizeString('senderPhone')"
                          style="margin-left: 12px;"
                        >
                          <el-input
                            v-model="searchForm.sender_phone"
                            :placeholder="generateCustomizeString('senderPhone')"
                            resize="horizontal"
                            @keyup.enter.native="onSearch"
                          ></el-input>
                        </el-form-item>
                      </el-col>
                    </el-col>
                    <el-col :span="24">
                      <el-col :span="6">
                        <el-form-item
                          :label="generateCustomizeString('expressCompany')"
                          style="margin-left: 28px;"
                        >
                          <el-select
                            v-model="searchForm.express_company_id"
                            :placeholder="generateCustomizeString('expressCompany')"
                            style="width: 176px;"
                          >
                            <el-option
                              v-for="item in companyOptions"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                            ></el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="6">
                        <el-form-item
                          :label="generateCustomizeString('expressNumber')"
                          style="margin-left: 14px;"
                        >
                          <el-input
                            v-model="searchForm.express_number"
                            :placeholder="generateCustomizeString('expressNumber')"
                            resize="horizontal"
                            @keyup.enter.native="onSearch"
                          ></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="6">
                        <el-form-item
                          :label="generateCustomizeString('goodsName')"
                          style="margin-left: 14px;"
                        >
                          <el-input
                            v-model="searchForm.goods_name"
                            :placeholder="generateCustomizeString('goodsName')"
                            resize="horizontal"
                            @keyup.enter.native="onSearch"
                          ></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="3">
                        <el-form-item>
                          <el-checkbox
                            v-model="searchForm.pay_type"
                            :label="generateCustomizeString('offlinePayment')"
                            border
                          ></el-checkbox>
                        </el-form-item>
                      </el-col>
                      <el-col :span="3">
                        <el-form-item>
                          <el-checkbox
                            v-model="searchForm.is_agent_order"
                            :label="generateCustomizeString('isAgentOrder')"
                            border
                          ></el-checkbox>
                        </el-form-item>
                      </el-col>
                    </el-col>
                    <!-- <el-col :span="24" v-if="searchForm.status == -1">
                      <el-col :span="8">
                        <el-form-item style="margin-left: 28px;">
                          <el-checkbox
                            v-model="filterOrderStatus"
                            :label="generateCustomizeString('filterOrderStatus')"
                            @change="filterOrderStatusClick"
                            border
                            size="medium"
                          ></el-checkbox>
                        </el-form-item>
                      </el-col>
                    </el-col> -->
                    <el-col :span="24">
                      <div
                        @click="searchOthers = !searchOthers"
                        v-show="searchOthers"
                        style="text-align: center; color: #969696;"
                      >
                        <i class="el-icon-arrow-up"></i>
                        <span style="font-size: 14px;">{{ generateCustomizeString('collapse') }}</span>
                      </div>
                    </el-col>
                  </div>
                </div>
              </div>
            </el-col>
          </el-form>
        </el-col>
      </el-row>
      <el-table
        ref="multipleTable"
        :data="orderData"
        tooltip-effect="dark"
        style="width: 100%; margin-bottom:60px;"
        v-loading.body="orderListLoading"
        @selection-change="handleSelectionChange"
        @sort-change="sortOrderByCreateDate"
        :sort-orders="['ascending', 'descending']"
      >
        <el-table-column type="selection" width="55" fixed="left"></el-table-column>
        <el-table-column prop="orderId" :label="generateCustomizeString('orderId')" width="150"></el-table-column>
        <el-table-column
          prop="customerName"
          :label="generateCustomizeString('customerName')"
          width="140"
        >
          <template slot-scope="scope">
            <div>
              {{ scope.row.customerName }}
            </div>
            <div v-if="scope.row.customerRemark">({{ scope.row.customerRemark }})</div>
          </template>
        </el-table-column>
        <el-table-column :label="generateCustomizeString('wechatImg')">
          <template slot-scope="scope">
            <span v-if="scope.row.headimgurl">
              <img
                :src="scope.row.headimgurl + '?imageView2/1/w/200/h/200/q/75|imageslim'"
                style="width:auto;height:50px;"
              />
            </span>
            <span v-else>{{ generateCustomizeString('notApplicable') }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="wechatName" :label="generateCustomizeString('wechatName')"></el-table-column>
        <el-table-column :label="generateCustomizeString('amountofGoods')" width="150">
          <template slot-scope="scope">
            <div v-if="scope.row.is_agent_order === true">
              <div>{{generateCustomizeString('sellPrice')}}：{{scope.row.amountofGoods}}</div>
              <div>{{generateCustomizeString('costFee')}}：{{scope.row.costGoodsFee}}</div>
              <div>{{generateCustomizeString('profit')}}：{{scope.row.profitofGoods}}</div>
            </div>
            <div v-else>
              <span>{{scope.row.amountofGoods}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="generateCustomizeString('shippingFee')" width="150">
          <template slot-scope="scope">
            <div v-if="scope.row.is_agent_order === true">
              <div>{{generateCustomizeString('sellShippingFee')}}：{{scope.row.shippingFee}}</div>
              <div>{{generateCustomizeString('costFee')}}：{{scope.row.costExpressFee}}</div>
              <div>{{generateCustomizeString('profit')}}：{{scope.row.profitofExpress}}</div>
            </div>
            <div v-else>
              <span>{{scope.row.shippingFee}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="totalFee" :label="generateCustomizeString('totalFee')" width="150">
          <template slot-scope="scope">
            <div v-if="scope.row.is_agent_order === true">
              <div>{{generateCustomizeString('sellTotalFee')}}：{{scope.row.totalFee}}</div>
              <div>{{generateCustomizeString('costFee')}}：{{scope.row.costTotal}}</div>
              <div>{{generateCustomizeString('profit')}}：{{scope.row.profitofTotal}}</div>
            </div>
            <div v-else>
              <span>{{scope.row.totalFee}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="generateCustomizeString('isPickUp')">
          <template slot-scope="scope">
            <el-tag
              type="warning"
              v-if="scope.row.isPickUp == '1'"
            >{{ generateCustomizeString('pickup') }}</el-tag>
            <el-tag v-else>{{ generateCustomizeString('post') }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column :label="generateCustomizeString('isAgentOrder')" width="120">
          <template slot-scope="scope">
            <el-tag
              type="info"
              v-if="scope.row.is_agent_order === true"
              @click="viewAgent(scope.row.agentId)"
            >{{scope.row.agentName}}</el-tag>
            <el-tag type="success" v-else>{{ generateCustomizeString('selfOperated') }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="orderStatus" :label="generateCustomizeString('orderStatus')"></el-table-column>
        <el-table-column
          :label="generateCustomizeString('orderCreateAt')"
          width="180"
          prop="orderCreateAt"
          :sortable="'custom'"
          :sort-orders="['ascending', 'descending']"
        >
          <template slot-scope="scope">{{ scope.row.orderCreateAt | toLocalTime}}</template>
        </el-table-column>
        <el-table-column fixed="right" :label="generateCustomizeString('operate')" width="120">
          <template slot-scope="scope">
            <a>
              <el-button
                @click="viewClick(scope.row)"
                type="text"
                size="small"
              >{{generateCustomizeString('view')}}</el-button>
            </a>
            <a>
              <el-button
                @click="editClick(scope.row)"
                type="text"
                size="small"
              >{{generateCustomizeString('edit')}}</el-button>
            </a>
            <el-button
              @click="expressClick(scope.row)"
              type="text"
              size="small"
              v-if="(scope.row.statusCode === 20 || scope.row.statusCode === 40 || scope.row.statusCode === 99) && scope.row.isPickUp === 0"
            >{{generateCustomizeString('express')}}</el-button>
            <el-button
              @click="writeOffClick(scope.row)"
              type="text"
              size="small"
              v-if="scope.row.isPickUp === 1 && scope.row.statusCode === 10"
            >{{generateCustomizeString('havePickedUp')}}</el-button>
            <el-button
              @click="updateStatus(scope.row)"
              type="text"
              size="small"
              v-if="scope.row.statusCode === 0 || scope.row.statusCode === 5"
            >{{generateCustomizeString('updateStatus')}}</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-dialog :title="generateCustomizeString('writeOffDetail')" :visible.sync="writeOffDialogVisible" width="40%" :append-to-body="true">
        <el-form ref="writeOffForm" :model="writeOffForm" label-width="25%">
          <div style="margin: 0 30px;">
            <el-form-item :label="generateCustomizeString('orderId')">
              <el-input v-model="writeOffForm.orderId" style="width: 90%;" disabled></el-input>
            </el-form-item>
            <el-form-item style="margin-top: 40px;">
              <div>
                <el-button @click="writeOffDialogVisible = false" style="width: 80px;">{{generateCustomizeString('cancel') }}</el-button>
                <el-button type="primary" @click="writeOffConfirm()" style="width: 80px; margin-left: 30px;">{{generateCustomizeString('confirm') }}</el-button>
              </div>
            </el-form-item>
          </div>
        </el-form>
      </el-dialog>

    </el-main>
    <el-footer style="position: fixed; bottom: 0; width: 100%; z-index:9999; padding-top:10px;">
      <el-row type="flex">
        <el-col style="padding-top: 5px;">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-size="numOfOrders"
            layout="total, prev, pager, next"
            :total="currentTotal"
          ></el-pagination>
        </el-col>
        <el-col>
          <div style="position: fixed; right: 30px;">
            <span
              style="font-size: 14px; color: #606266;"
            >{{ generateCustomizeString('ordersPerPage') }}:</span>
            <el-select v-model="numOfOrders" style="width: 80px;" @change="selectNumOfOrders()">
              <el-option
                v-for="item in numOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
        </el-col>
      </el-row>
    </el-footer>

    <el-dialog
      :title="generateCustomizeString('express')"
      :visible.sync="dialogVisible "
      width="70%"
      :before-close="closeDialog"
    >
      <div style="margin-top: -10px; padding: 0 20px;">
        <div style="line-height: 36px; font-size: 16px;">
          <span>{{ generateCustomizeString('tradeNo') }}:</span>
          <span>{{this.expressData.out_trade_no}}</span>
        </div>

        <el-table
          :data="orderExpressData"
          tooltip-effect="dark"
          style="width: 100%"
          v-loading="orderExpressDataLoading"
        >
          <el-table-column prop="expressNumber" :label="generateCustomizeString('expressNumber')"></el-table-column>
          <el-table-column prop="expressCompany" :label="generateCustomizeString('expressCompany')"></el-table-column>
          <el-table-column prop="queryUrl" :label="generateCustomizeString('queryUrl')">
            <template slot-scope="scope">
              <span>
                <a
                  :href="scope.row.queryUrl"
                  target="_blank"
                  style="color: #409EFF;"
                >{{scope.row.queryUrl}}</a>
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="express" :label="generateCustomizeString('express')">
            <template slot-scope="scope">
              <el-button
                @click="expressTraceClick(scope.row)"
                type="text"
                size="small"
              >{{ generateCustomizeString('trackShipping') }}</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-dialog
          :title="generateCustomizeString('shippingInfo')"
          :visible.sync="expressInfoDialogVisible"
          width="60%"
          :append-to-body="true"
        >
          <p
            style="padding-left: 30px; font-size: 16px;"
          >{{ generateCustomizeString('expressCompany') }}{{this.expressCompany}}</p>
          <p
            style="padding-left: 30px; font-size: 16px;"
          >{{ generateCustomizeString('expressNumber') }}{{this.expressNumber}}</p>
          <el-table
            :data="expressInfoData"
            tooltip-effect="dark"
            style="width: 100%; margin-top: 20px;"
            v-loading="expressInfoLoading"
          >
            <el-table-column prop="expressTime" :label="generateCustomizeString('expressTime')"></el-table-column>
            <el-table-column
              prop="expressContext"
              :label="generateCustomizeString('expressContext')"
            ></el-table-column>
          </el-table>
        </el-dialog>
      </div>
    </el-dialog>

    <print-order ref="printOrder"></print-order>
    <paid-excel ref="paidExcel" @onRefersh="onRefersh" :is-order-status="searchForm.status"></paid-excel>
    <picking-excel ref="pickingExcel"></picking-excel>
  </el-container>
</template>

<script>
import { generateCustomizeString } from '@/utils/i18n'
import request from '@/utils/request'
import dayjs from 'dayjs'
import PrintOrder from './PrintOrder'
import PaidExcel from './PaidExcel'
import PickingExcel from './PickingExcel'
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition'
import Vue from 'vue'

Vue.component(CollapseTransition.name, CollapseTransition)

const originOrderSearchFrom = {
  datetimeRange: [],
  out_trade_no: '',
  phone: '',
  status: -1,
  wx_nickname: '',
  pay_type: false,
  consignee_name: '',
  consignee_phone: '',
  sender_name: '',
  sender_phone: '',
  express_company_id: '',
  express_number: '',
  goods_name: '',
  is_agent_order: false,
  is_pick_up: false,
  order: 'created_at_desc'
}
export default {
  name: 'OrderList',
  components: {
    PrintOrder,
    PaidExcel,
    PickingExcel
  },
  // props: {
  //   isOrderStatus: {
  //     type: Number,
  //     default: 0
  //   }
  // },
  data() {
    return {
      path: '',
      orderData: [],
      expressData: [],
      expressesInfoData: [],
      expressLogData: [],
      orderExpressData: [],
      expressInfoData: [],
      orderListLoading: false,
      orderExpressDataLoading: false,
      expressInfoLoading: false,
      currentPage: 1,
      currentTotal: 0,
      expressInfoDialogVisible: false,
      companyOptions: [],
      datetimeRangePickerOptions: {
        shortcuts: [
          {
            text: this.generateCustomizeString('lastWeek'),
            onClick(picker) {
              const end = dayjs().endOf('day')
              const start = end
                .clone()
                .subtract(1, 'week')
                .startOf('day')
              picker.$emit('pick', [start.toDate(), end.toDate()])
            }
          },
          {
            text: this.generateCustomizeString('lastMonth'),
            onClick(picker) {
              const end = dayjs().endOf('day')
              const start = end
                .clone()
                .subtract(1, 'month')
                .startOf('day')
              picker.$emit('pick', [start.toDate(), end.toDate()])
            }
          },
          {
            text: this.generateCustomizeString('lastThreeMonths'),
            onClick(picker) {
              const end = dayjs().endOf('day')
              const start = end
                .clone()
                .subtract(3, 'month')
                .startOf('day')
              picker.$emit('pick', [start.toDate(), end.toDate()])
            }
          }
        ]
      },
      searchForm: Object.assign({}, originOrderSearchFrom),
      multipleSelection: [],
      dialogVisible: false,
      selectionOrderId: '',
      selectId: '',
      selectExpressNumber: '',
      selectDate: [],
      selectExpressDetail: [],
      searchOthers: false,
      activeNames: '1',
      expressCompany: '',
      expressNumber: '',
      numOfOrders: 15,
      numOptions: [
        {
          value: 15,
          label: '15'
        },
        {
          value: 50,
          label: '50'
        },
        {
          value: 100,
          label: '100'
        },
        {
          value: 1000,
          label: '1000'
        }
      ],
      orderByOptions: [
        {
          value: 'created_at_desc',
          label: this.generateCustomizeString('createdDesc')
        },
        {
          value: 'created_at_asc',
          label: this.generateCustomizeString('createdAsc')
        },
        {
          value: 'updated_at_desc',
          label: this.generateCustomizeString('updatedDesc')
        },
        {
          value: 'updated_at_asc',
          label: this.generateCustomizeString('updatedAsc')
        }
      ],
      writeOffDialogVisible: false,
      writeOffForm: {
        orderId: '',
        id: ''
      }
      // filterOrderStatus: false
    }
  },
  methods: {
    generateCustomizeString,
    selectNumOfOrders() {
      this.fetchOrderData(1)
    },
    onQuickSearch(statusValue) {
      this.searchForm.status = statusValue
      this.onSearch()
    },
    onSearch() {
      this.$refs.searchForm.validate(valid => {
        if (valid) {
          const params = Object.assign({}, this.searchForm)
          if (
            this.searchForm.datetimeRange &&
            this.searchForm.datetimeRange.length === 2
          ) {
            console.log(this.searchForm.datetimeRange)
            const dates = this.searchForm.datetimeRange.map(date =>
              dayjs(date)
                .utc()
                .format('YYYY-MM-DD HH:mm:ss')
            )
            console.log(dates)
            params.start_created_at = dates[0]
            params.end_created_at = dates[1]
            delete params.datetimeRange
          }

          if (this.searchForm.pay_type === true) {
            params.pay_type = 'IE9999'
          } else {
            params.pay_type = ''
          }

          this.fetchOrderData(1)
        } else {
          console.log('data error')
        }
      })
    },
    onReset() {
      const status = this.searchForm.status
      this.searchForm = Object.assign({}, originOrderSearchFrom)
      if (status === 20) {
        this.searchForm.order = 'updated_at_desc'
      }
      // this.filterOrderStatus = false

      this.$route.params.customerId = null
      this.$route.params.displayName = null
      this.fetchOrderData(1)
    },
    onRefersh() {
      this.fetchOrderData(this.currentPage)
    },
    orderSortClick() {
      this.fetchOrderData(this.currentPage)
    },
    editClick(row) {
      this.$router.push({
        name: 'OrderEdit',
        params: { orderId: row.id }
      })
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    viewAgent(id) {
      this.$router.push({
        name: 'EditAgent',
        params: { agentId: id }
      })
    },
    viewClick(row) {
      this.$router.push({
        name: 'OrderView',
        params: { orderId: row.id }
      })
    },
    expressClick(row) {
      this.dialogVisible = true
      this.fetchExpressInfo(row)
    },
    expressTraceClick(row) {
      this.expressInfoDialogVisible = true
      this.expressInfoLoading = true
      this.expressCompany = row.expressCompany
      this.expressNumber = row.expressNumber
      this.expressInfoData = []
      request({
        url: '/express/trace/detail',
        method: 'get',
        params: {
          express_number: row.expressNumber,
          express_company_id: row.expressCompanyId
        }
      })
        .then(response => {
          const expressInfo = []
          if (response.data.trades.length > 0) {
            for (var i = 0; i < response.data.trades.length; i++) {
              var obj = {}
              obj.expressTime = response.data.trades[i].time
              obj.expressContext = response.data.trades[i].context

              expressInfo[i] = obj
            }
          }
          this.expressInfoData = expressInfo
        })
        .catch(error => {
          console.warn(error)
        })
        .finally(() => {
          this.expressInfoLoading = false
        })
      console.log(row)
    },
    closeDialog() {
      this.dialogVisible = false
    },
    handleCurrentChange(val) {
      this.fetchOrderData(val)
    },

    // 订单状态:0未付款 10已付款（待发货）15配送中 20已发货（待完成）30未付款已发货 40交易完成 50申请退款 60退款完成 99已关闭
    getOrderStatus() {
      var status = ''
      switch (this.searchForm.status) {
        case 0:
          status = this.generateCustomizeString('unpaid')
          break
        case 5:
          status = this.generateCustomizeString('partialyPaid')
          break
        case 10:
          status = this.generateCustomizeString('paid')
          break
        case 15:
          status = this.generateCustomizeString('picking')
          break
        case 20:
          status = this.generateCustomizeString('shipped')
          break
        case 30:
          status = this.generateCustomizeString('unpaidShipped')
          break
        case 40:
          status = this.generateCustomizeString('transactionComplete')
          break
        case 50:
          status = this.generateCustomizeString('requestARefund')
          break
        case 60:
          status = this.generateCustomizeString('refundCompleted')
          break
        case 99:
          status = this.generateCustomizeString('closed')
          break
        default:
          status = this.generateCustomizeString('unpaid')
      }
      return status
    },
    fetchExpressCompany() {
      return new Promise((resolve, reject) => {
        request({
          url: 'express/shop/company/list',
          method: 'get'
        })
          .then(response => {
            const data = response.data
            for (let i = 0; i < response.data.length; i++) {
              var obj = {}
              obj.value = response.data[i].express_company_id
              obj.label = response.data[i].company.name
              data[i] = obj
            }
            this.companyOptions = data
            resolve()
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    fetchOrderData(page) {
      if (this.orderListLoading) {
        return
      }
      this.orderListLoading = true

      const params = {
        page: page,
        ...this.searchForm,
        page_size: this.numOfOrders
      }

      if (params.is_pick_up === false) {
        delete params.is_pick_up
      }

      if (params.datetimeRange && params.datetimeRange.length === 2) {
        const dates = params.datetimeRange.map(date =>
          dayjs(date)
            .utc()
            .format('YYYY-MM-DD HH:mm:ss')
        )
        params.start_created_at = dates[0]
        params.end_created_at = dates[1]
      }
      delete params.datetimeRange

      if (params.pay_type === true) {
        params.pay_type = 'IE9999'
      } else {
        params.pay_type = ''
      }

      if (this.$route.params.customerId) {
        params['customer_id'] = this.$route.params.customerId
      }

      if (this.searchForm.status === -1) {
        delete params.status
      }

      request({
        url: '/order-list',
        method: 'get',
        params: params
      })
        .then(response => {
          const data = response.data
          const meta = response.meta
          // var timezone = 'Pacific/Auckland'

          for (let i = 0; i < response.data.length; i++) {
            var obj = {}
            obj.id = response.data[i].id
            obj.orderId = response.data[i].out_trade_no
            obj.customerName = response.data[i].customer_name
            if (response.data[i].customer) {
              obj.customerRemark = response.data[i].customer.remark
            }
            if (
              response.data[i].customer &&
              response.data[i].customer.wechat_auths.length &&
              response.data[i].customer.wechat_auths[0].user_info
            ) {
              obj.headimgurl =
                response.data[i].customer.wechat_auths[0].user_info[
                  'headimgurl'
                ]
              obj.wechatName =
                response.data[i].customer.wechat_auths[0].user_info['nickname']
            } else {
              obj.wechatName = this.generateCustomizeString('notApplicable')
            }
            obj.amountofGoods =
              'NZD $' + parseFloat(response.data[i].goods_fee / 100).toFixed(2)
            obj.profitofGoods =
              'NZD $' +
              parseFloat(response.data[i].goods_profit / 100).toFixed(2)
            obj.costGoodsFee =
              'NZD $' +
              parseFloat(
                response.data[i].cost_goods_fee_after_discounted / 100
              ).toFixed(2)
            obj.shippingFee =
              'NZD $' +
              parseFloat(response.data[i].express_fee / 100).toFixed(2)
            obj.profitofExpress =
              'NZD $' +
              parseFloat(response.data[i].express_profit / 100).toFixed(2)
            obj.costExpressFee =
              'NZD $' +
              parseFloat(
                response.data[i].cost_express_fee_after_discounted / 100
              ).toFixed(2)
            obj.totalFee =
              'NZD $' + parseFloat(response.data[i].fee / 100).toFixed(2)
            obj.profitofTotal =
              'NZD $' + parseFloat(response.data[i].profit / 100).toFixed(2)
            obj.costTotal =
              'NZD $' +
              parseFloat(
                (response.data[i].fee - response.data[i].profit) / 100
              ).toFixed(2)
            obj.statusCode = response.data[i].status
            obj.orderStatus_en = response.data[i].status_name_en
            obj.orderStatus_zh = response.data[i].status_name_zh
            obj.orderCreateAt = response.data[i].created_at
            obj.isPickUp = response.data[i].is_pick_up
            obj.is_agent_order = response.data[i].is_agent_order
            if (response.data[i].shop) {
              obj.agentName = response.data[i].shop.display_shop_name
              obj.agentId = response.data[i].shop.id
            }
            data[i] = obj
          }

          this.orderData = data

          this.formatOrderStatus()

          // Filter unpaid and closed order
          // if (this.filterOrderStatus) {
          //   this.orderData = this.orderData.filter(function(order) {
          //     return order.statusCode !== 0
          //   })
          //   this.orderData = this.orderData.filter(function(order) {
          //     const status = order.statusCode.toString()
          //     return status.substr(0, 1) !== '9'
          //   })
          // }

          this.currentPage = meta.current_page
          this.currentTotal = meta.total
        })
        .catch(error => {
          console.warn(error)
        })
        .finally(() => {
          this.orderListLoading = false
        })
    },
    updateStatus(row) {
      request({
        url: `order/${row.orderId}/check/paid`,
        method: 'get'
      }).then(() => {
        this.fetchOrderData(this.currentPage)
      })
    },
    fetchExpressInfo(row) {
      if (this.orderExpressDataLoading) return
      this.orderExpressDataLoading = true
      request({
        url: 'order/' + row.id,
        method: 'get'
      })
        .then(response => {
          const data = response.data
          const dataLog = response.data.order_operation_logs
          const expressesInfo = response.data.expresses

          for (let j = 0; j < response.data.order_operation_logs.length; j++) {
            var sobj = {}
            sobj.expressCreateAt =
              response.data.order_operation_logs[j].created_at
            sobj.expressDetail = response.data.order_operation_logs[j].comments

            dataLog[j] = sobj
          }

          const orderExpresses = []
          if (response.data.expresses.length > 0) {
            for (var i = 0; i < response.data.expresses.length; i++) {
              var obj = {}
              if (
                response.data.expresses[i].express_company &&
                response.data.expresses[i].express_company_id > 0
              ) {
                obj.expressCompanyId =
                  response.data.expresses[i].express_company_id
                obj.expressCompany =
                  response.data.expresses[i].express_company.name
                obj.queryUrl =
                  response.data.expresses[i].express_company.order_query_url
              } else {
                obj.expressCompanyId = null
                obj.expressCompany = ''
                obj.queryUrl = ''
              }
              obj.expressNumber = response.data.expresses[i].express_number

              orderExpresses[i] = obj
            }
          }
          this.orderExpressData = orderExpresses
          this.expressData = data
          this.expressesInfoData = expressesInfo
          this.expressLogData = dataLog
        })
        .catch(error => {
          console.warn(error)
        })
        .finally(() => {
          this.orderExpressDataLoading = false
        })
    },
    printOrder() {
      const selections = this.$refs.multipleTable.selection
      if (selections.length === 0) {
        alert(this.generateCustomizeString('pleaseSelectOrders'))
        return
      }
      let ids = ''
      for (var i = selections.length - 1; i >= 0; i--) {
        ids += selections[i].id
        if (i !== 0) ids += ','
      }
      this.$refs.printOrder.handlePrintClick(ids)
    },
    paidExcel() {
      const selections = this.$refs.multipleTable.selection
      if (selections.length === 0) {
        alert(this.generateCustomizeString('pleaseSelectOrders'))
        return
      }
      let ids = ''
      for (var i = selections.length - 1; i >= 0; i--) {
        ids += selections[i].id
        if (i !== 0) ids += ','
      }
      this.$refs.paidExcel.handleExcelClick(ids)
    },
    pickingExcel() {
      const selections = this.$refs.multipleTable.selection
      if (selections.length === 0) {
        alert(this.generateCustomizeString('pleaseSelectOrders'))
        return
      }
      let ids = ''
      for (var i = selections.length - 1; i >= 0; i--) {
        ids += selections[i].id
        if (i !== 0) ids += ','
      }
      console.log(ids)
      this.$refs.pickingExcel.handleExcelClick(ids)
    },
    writeOffClick(row) {
      this.writeOffDialogVisible = true
      this.writeOffForm.orderId = row.orderId
      this.writeOffForm.id = row.id
    },
    writeOffConfirm() {
      var data = {
        order_id: this.writeOffForm.id
      }
      request({
        url: '/write-off',
        method: 'post',
        data
      })
        .then(res => {
          if (res.status === 0) {
            this.$message({
              message: this.generateCustomizeString('writeOffSuccessfully'),
              type: 'success'
            })
            this.fetchOrderData(this.currentPage)
          } else {
            this.$message.error(this.generateCustomizeString('writeOffFailed'))
          }
        })
        .catch(error => {
          console.log(error)
          this.$message.error(this.generateCustomizeString('writeOffFailed'))
        })
        .finally(() => {
          this.writeOffDialogVisible = false
          this.writeOffForm.id = ''
          this.writeOffForm.orderId = ''
        })
    },
    sortOrderByCreateDate(column) {
      if (column.order == 'ascending') {
        this.searchForm.order = 'created_at_asc'
        this.fetchOrderData(this.currentPage)
      } else if (column.order == 'descending') {
        this.searchForm.order = 'created_at_desc'
        this.fetchOrderData(this.currentPage)
      }
    },
    // filterOrderStatusClick() {
    //   this.fetchOrderData(this.currentPage)
    // },
    formatOrderStatus() {
      this.orderData.forEach(val => {
        val.orderStatus = val[`orderStatus_${this.$store.state.app.language}`]
      })
    }
  },
  created: function() {
    if (this.searchForm.status === 20) {
      this.searchForm.order = 'updated_at_desc'
    }
    Promise.all([this.fetchExpressCompany()])
      .then(result => {
        this.fetchOrderData(1)
        this.path = this.$route.path
      })
      .catch(error => {
        console.warn(error)
      })
  },
  activated: function() {
    if (this.$route.params.outTradeNo) {
      this.searchForm.out_trade_no = this.$route.params.outTradeNo
      this.$route.params.outTradeNo = null
    }
  },
  computed: {
    viewActived() {
      return this.$store.state.tagsView.changedViewEvent
    }
  },
  watch: {
    '$store.state.app.language'(newValue, oldValue) {
      this.formatOrderStatus()
    },
    viewActived: function(newValue) {
      if (window.location.href.match(this.path)) {
        this.onRefersh()
      }
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.el-header,
.el-footer {
  background-color: #eee;
  color: #333;
}

.search-form-inline {
  max-height: 60px;
}
</style>
